import styled, { createGlobalStyle } from "styled-components";
import { breakpoints } from "root/libs/ui-styleguide/src";
import { Headline } from "root/libs/ui-components/src";

// NOTE: These global styles will override logistics print styles for heading elements.
export const GlobalPrintStyle = createGlobalStyle`
  @media print{
    .c-nav {
      background: transparent;
    }
    .c-page-headline {
      display: none;
    }
    ::placeholder { /* WebKit browsers */
      color: transparent !important;
    }
  }
`;

export const BypassBlockWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  justify-items: center;
  flex-direction: column;
  height: 100px;
  margin-top: var(--dui-size-space-50x);
  margin-bottom: var(--dui-size-space-24x);

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin: var(--dui-size-space-72x) var(--dui-size-space-10x)
      var(--dui-size-space-40x);
    flex-direction: row;
    height: auto;
    justify-content: flex-end;

    .bypassBlock:first-child {
      margin-right: 10px;
    }
  }

  @media print {
    display: none;
  }
`;

export const ProductChip = styled.div`
  background-color: var(--dui-color-gray-300);
  padding: var(--dui-size-space-2x) var(--dui-size-space-5x);
  margin: var(--dui-size-space-5x) 0px 0px 0px;
  border-radius: var(--gaq-size-space-5px);
  font-size: var(--dui-size-font-sm);
  color: var(--dui-color-black-400);
  border: var(--dui-size-space-1) solid #ddd;
  letter-spacing: 0.5px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  cursor: pointer;

  strong {
    margin-right: var(--dui-size-space-5x);
  }

  @media print {
    display: none;
  }

  &:hover {
    border-color: var(--dui-color-gray-500);
    background-color: var(--dui-color-gray-500);
    color: var(--dui-color-black-500);
  }

  &:focus,
  &:focus-visible {
    outline: var(--dui-size-space-1x) solid #007acc;
    outline-offset: var(--dui-size-space-1x);
    z-index: 1;
  }
`;

export const StepperIndicator = styled.div`
  width: var(--dui-size-space-50x);
  max-width: 1200px;
  background: var(--dui-color-yellow-500);
  border-radius: var(--dui-size-space-2x);
  padding: var(--dui-size-space-4x) var(--dui-size-space-6x);
  font-family: Delivery;
  font-weight: 800;
  font-size: var(--dui-size-space-7x);
  line-height: 130%;
  letter-spacing: 0px;
  text-align: center;
`;

export const OverAllWrapper = styled.div`
  ${({ stepperEnabled }) =>
    stepperEnabled &&
    `
      background: rgb(249, 249, 249);
      padding-top: var(--gaq-size-space-30px);
      padding-bottom: var(--dui-size-space-10x);

      @media screen and (min-width: ${breakpoints.tablet}) {
        margin: var(--dui-size-space-20x);
        padding-top: 0;
        padding-bottom: var(--gaq-size-space-30px);
        border-radius: var(--dui-size-space-10x);
        background: var(--Tokens-Gray-25, #F9F9F9);
        border: 1px solid var(--Stroke-muted, #0000001A);

        max-width: 100rem;
        width: auto;

        &:not(.no-padding) {
          padding-left: 0;
          padding-right: 0;
          margin-left: calc(var(--dui-size-space-10x) + var(--dui-size-space-5x));
          margin-right: calc(var(--dui-size-space-10x) + var(--dui-size-space-5x));
        }
      }

      @media screen and (min-width: ${breakpoints.desktop}) {
        padding-bottom: var(--gaq-size-space-30px);
        &:not(.no-padding) {
          margin-left: auto;
          margin-right: auto;
        }
      }
    `}
`;

export const StyledHeadline = styled(Headline)`
  margin-bottom: var(--gaq-size-space-30px);
  padding-top: var(--dui-size-space-20x);
  padding-top: ${(props) =>
    props.stepperEnabled
      ? "var(--dui-size-space-10x)"
      : "var(--dui-size-space-20x)"};

  @media print {
    display: none;
  }
`;

export const StyledHeadlineVariant = styled(StyledHeadline)`
  text-align: center;
`;
